import { useState } from "react";

export function useLoading() {
    const [crewsLoading, setCrewsLoading] = useState(false);
    const [unassignedLoading, setUnassignedLoading] = useState(false);
    return { crewsLoading, setCrewsLoading, unassignedLoading, setUnassignedLoading };
}